import { render, staticRenderFns } from "./ModalDocument.vue?vue&type=template&id=ecfcf2e4&scoped=true"
import script from "./ModalDocument.vue?vue&type=script&lang=js"
export * from "./ModalDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfcf2e4",
  null
  
)

export default component.exports